import { useTranslation } from "react-i18next";
import { Bank, DocumentText1 } from "iconsax-react";
import { FileViewer } from "@/shared/ui";
import type { BankingSection as BankingSectionType } from "../../types/personalSheet";
import ProfileDataRow from "../ProfileDataRow";

interface Props {
  banking: BankingSectionType | null;
}

export default function BankingSection({ banking }: Props) {
  const { t } = useTranslation("EmployeePortal");

  if (!banking) {
    return <p className="text-body-regular-md content-base-secondary">{t("personalSheet.empty.banking")}</p>;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col">
        <ProfileDataRow icon={Bank} label={t("personalSheet.fields.bankName")} value={banking.bank_name} />
        <ProfileDataRow icon={DocumentText1} label={t("personalSheet.fields.ibanAccount")} value={banking.iban_account} />
        <ProfileDataRow icon={DocumentText1} label={t("personalSheet.fields.bikNumber")} value={banking.bik_number} />
      </div>
      {banking.bank_certificate_file_url && (
        <div className="flex flex-col gap-1.5">
          <span className="text-label-sm content-base-secondary">{t("personalSheet.fields.bankCertificateFile")}</span>
          <FileViewer existingFileUrl={banking.bank_certificate_file_url} isDownloadable />
        </div>
      )}
    </div>
  );
}
